import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { styled } from 'linaria/react';
import { Main3DButton } from '../Elements/Texts/Button3D';
import { ReactComponent as MapPin } from '../../../svg/MapPin.svg';
import t from '@jetshop/intl';
import { ReactComponent as Carrot } from '../../../svg/Carrot.svg';
import { StepHeaderTextDescription } from '../Elements/StepHeaderTextDescription';
import ColorsAndTextilesConfig from '../Config/colorsAndTextiles.config';
import VariantTextileMapConfig from '../Config/variantTextileMap.config';
import inspirationImagesConfig from '../Config/inspirationImages.config';
import { ProductPriceSummary } from '../Elements/Product/ProductPriceSummary';
import Popup from '../Share/Popup'
import getProduct from '../Data/GetProduct';
import Articles3DConfig from '../Config/articles.config';

const LastStep = styled('div')`
  display: grid;
  margin: 0 auto 2rem;
  grid-auto-columns: auto;
  grid-template-rows: auto;
  overflow: hidden;
  width: 100%;
  max-height: 500px;
  white-space: nowrap;
  scroll-behavior: smooth;

  /* width */
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #911827;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #720714;
  }

  @media screen and (max-width: 800px) {
    margin: 0 auto 2rem;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    width: 100%;
    cursor: default;
    height: max-content;
    max-height: unset;
    white-space: initial;
  }
`;
const LastStepImage = styled('img')`
  width: auto;
  grid-row: 1;
  grid-column: auto;
  height: 100%;
  @media screen and (max-width: 800px) {
    height: auto;
    width: 100%;
  }
  @media screen and (max-width: 600px) {
  }
`;
const StyledWrapperStepSix = styled('div')`
  display: flex;
  flex-direction: column;
  margin: 0 auto 4rem;
  max-width: 1280px;
  padding: 0 60px;

  @media screen and  (max-width: 1023px){
    padding: 0 10px;
  }

  @media screen and (max-width: 800px) {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: max-content;
    background: #fff;
    padding: 15px 15px;
    margin: 0 auto;
    z-index: 100000;
    max-width: unset;
    border-radius: 30px 30px 0 0;
  }
  @media screen and (max-width: 800px) {
  }
`;
const StyledButtonWrapper = styled('div')`
  text-align: center;
  display: flex;
  flex-direction: row;
  gap: 15px;

  @media screen and (max-width: 1200px) {
    flex-wrap: wrap;
  }

  @media screen and (max-width: 1023px) {
    padding: 0 10px;
  }
`;
const StepHeader = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  width: 100%;
  position: relative;
  margin: 0 auto 2rem;
  height: 35px;
  max-width: 1280px;
  padding: 0 60px;
  @media screen and (max-width: 1023px) {
    padding: 0 10px;
  }

  @media screen and (max-width: 800px) {
    margin: 0 auto 1rem;
    padding: 0;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
    display: flex;
    flex-direction: row;
  }
`;
const StepHeaderText = styled('div')`
  font-weight: bold;
  font-size: 18px;
  @media screen and (max-width: 800px) {
    font-size: 16px;
  }
`;
const StepHeaderButton = styled('div')`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  border-radius: 50px;
  margin: 0 auto;
  background: #911827;
  width: 100px;
  height: 35px;
  position: absolute;
  right: 0;
  cursor: pointer;
  display: ${({ active }) => (active ? 'flex' : 'none')};

  @media screen and (max-width: 800px) {
    position: relative;
    margin: 0;
  }
`;
const StepHeaderButtonPrev = styled('div')`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  border-radius: 50px;
  margin: 0 auto;
  background: #911827;
  width: 35px;
  height: 35px;
  position: absolute;
  left: 0;
  cursor: pointer;
  display: flex;
  
  &.hidden {
    opacity: 0;
    visibility: hidden;
  }

  @media screen and (max-width: 800px) {
    position: relative;
    margin: 0;
  }
`;
const StepHeaderButtonText = styled('p')`
  margin: 5px 0;
  color: #fff;
  text-transform: uppercase;
  font-size: 12px;
`;
const SvgWrapper = styled('div')`
  width: 15px;
  transition: transform 0.3s;

  &.black {
    svg {
      use {
        fill: #000;
      }
    }
  }
  
  svg {
    use {
      fill: #fff;
    }
  }
  transform: rotate(-90deg);
`;
const SvgWrapperReverse = styled('div')`
  width: 15px;
  transition: transform 0.3s;

  &.black {
    svg {
      use {
        fill: #000;
      }
    }
  }
  
  svg {
    use {
      fill: #fff;
    }
  }
  transform: rotate(90deg);
`;
const SvgWrapperDown = styled('div')`
  width: 15px;
  transition: transform 0.3s;

  svg {
    use {
      fill: #fff;
    }
  }
  transform: rotate(0deg);

  &.active {
    transform: rotate(180deg);
  }
`;

const CharpstarContainer = styled('div')`
  width: 100%;
  aspect-ratio: 4 / 3;
  padding: 0;
  margin: 0;
  background: #f5f5f5;
  grid-row: 1;
  grid-column: auto;
  height: 500px;
  @media screen and (max-width: 1023px) {
    width: 100%;
  }
  @media screen and (max-width: 800px) {
    max-height: 55vh;
    width: 100vw;
  }
  @media screen and (max-width: 600px) {
    max-height: 55vh;
    width: 100vw;
  }
`;
const ProductInfo = styled('div')`
  margin: 0 auto 2rem;

  @media screen and (max-width: 800px) {
    text-align: left;
    margin: 0 0 1rem;
    font-size: 14px;
  }
`;
const ProductName = styled('p')`
  margin: 0 auto;
`;

const ProductType = styled('p')`
  margin: 0 auto;
`;
const TextInfo = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  opacity: 1;
  transition: all 0.25s;
  height: auto;
  &.hide {
    opacity: 0;
    height: 0;
    transition: all 0.25s;
  }
`;

const PreviousButton = styled('span')`
  display: none;
  position: absolute;
  top: 50%;
  left: 15px;
  background: #fff;
  border-radius: 100%;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 50px;
  border: none;
  transform: translateY(-50%);
  box-shadow: 0px 0px 2px #000;
  z-index: 2;
  cursor: pointer;
  
  @media screen and (max-width: 800px) {
    display: none;
  }
`

const NextButton = styled('span')`
  display: none;
  position: absolute;
  top: 50%;
  right: 15px;
  background: #fff;
  border-radius: 100%;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 50px;
  border: none;
  transform: translateY(-50%);
  box-shadow: 0px 0px 2px #000;
  z-index: 2;
  cursor: pointer;
  @media screen and (max-width: 800px) {
    display: none;
  }
`

const GetBrand = (name) => {
  const brand = name.split(' ')[0]
  if (brand.toLowerCase() === 'lindö') {
    return 'lindo'
  }

  return brand.toLowerCase()
}

export const SummarySharedStep = ({
                              currentStep,
                              setCurrentStep,
                              activeProduct,
                              setActiveProduct,
                              activeCategory,
                              setActiveCategory,
                              activeTextileIndex,
                              setActiveTextileIndex,
                              activeLeg,
                              setActiveLeg,
                            }) => {
  const [isCharpstarLoaded, setIsCharpstarLoaded] = useState(false);
  const [activeText, setActiveText] = useState(false);
  const [defaultArticleNumberForVariant, setDefaultArticleNumberForVariant] = useState(null);
  const [availableVariants, setAvailableVariants] = useState([]);
  const [articleNumber, setArticleNumber] = useState(null);
  const [articlePrice, setArticlePrice] = useState(null);
  const [legs, setLegs] = useState([]);
  const [textiles, setTextiles] = useState([]);
  const [hasAdded, setHasAdded] = useState(false)
  const [addToCartClicked, setAddToCartClicked] = useState(false)
  const [share, setShare] = useState(false)
  const [productPrice, setProductPrice] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null)
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [charpstARConfig, setCharpstARConfig] = useState(null);

  const scrollRef = useRef(null);
  const scrollRef2 = useRef(null);

  const scrollBy = (distance) => {
    const unit = scrollRef.current.scrollWidth / 100
    if (distance < 0) {
      scrollRef.current.scrollBy({ left: -(5 * unit), behavior: "smooth" });
    } else {
      scrollRef.current.scrollBy({ left: 5 * unit, behavior: "smooth" });
    }
  };
  const scrollBy2 = (distance) => {
    const unit = scrollRef2.current.scrollWidth / 100
    if (distance < 0) {
      scrollRef2.current.scrollBy({ left: -(5 * unit), behavior: "smooth" });
    } else {
      scrollRef2.current.scrollBy({ left: 5 * unit, behavior: "smooth" });
    }
  };

  const productData = activeProduct?.defaultArticleNumber
    ? getProduct(activeProduct.defaultArticleNumber)
    : null;

  useEffect(() => {
    (async () => {
      try {
        // Note: This only works if the script is an ES module AND your bundler allows it!
        const module = await import(/* webpackIgnore: true */ 'https://js.charpstar.net/MobelMastarna/charpstAR-MobelMastarna-v2.js');
        setCharpstARConfig(module.default);
        // Use module exports here
      } catch (error) {
        console.error('Failed to load module:', error);
      }
    })();
  }, [charpstARConfig]);

  useEffect(() => {
    setDefaultArticleNumberForVariant(activeProduct?.defaultArticleNumber);
  }, [activeProduct?.defaultArticleNumber]);

  useEffect(() => {
    setArticleNumber(activeProduct?.selectedVariant);
  }, [activeProduct?.selectedVariant]);

  useEffect(() => {
    if (
      charpstARConfig === null ||
      typeof charpstARConfig === 'undefined' ||
      !activeProduct.defaultArticleNumber ||
      isCharpstarLoaded
    ) {
      return;
    }
    charpstARConfig
      .init()
      .then(() => {
        const intervalId = setInterval(() => {
          if (charpstARConfig.viewerElement !== null) {
            clearInterval(intervalId);
            setIsCharpstarLoaded(true);
          } else {
            // Waiting for viewerElement to be ready
          }
        }, 10);
      })
      .catch((error) => {
        console.error('charpstARConfig initialization failed:', error);
      });
  }, [activeProduct.defaultArticleNumber, charpstARConfig, isCharpstarLoaded]);

  useEffect(() => {
    if (charpstARConfig === null || !isCharpstarLoaded || textiles.length > 0) return;
    const intervalId = setInterval(() => {
      const fabrics = charpstARConfig.getAvailableFabricMaterials();
      if (Array.isArray(fabrics) && fabrics.length > 0) {
        const textileArr = fabrics.map((fabric, index) => ({
          id: index,
          name: fabric,
          image: '',
          hexColor: '',
        }));
        setTextiles(textileArr);
        if (activeTextileIndex !== null) {
          charpstARConfig.setFabricMaterial(textileArr[activeTextileIndex].name);
        }
        clearInterval(intervalId);
      }
    }, 100);
    return () => clearInterval(intervalId);
  }, [isCharpstarLoaded, textiles.length, activeTextileIndex, charpstARConfig]);

  useEffect(() => {
    if (!isCharpstarLoaded || legs.length > 0) return;
    const intervalId = setInterval(() => {
      const legMaterials = charpstARConfig.getAvailableLegMaterials();
      if (Array.isArray(legMaterials) && legMaterials.length > 0) {
        const legData = activeProduct.legs
        let legsArr = [];
        legMaterials.forEach((leg, index) => {
          if (legData && legData.length) {
            legData.forEach((legItem, legIndex) => {
              if (legItem.name.toLowerCase() === leg.toLowerCase()) {
                legsArr.push({
                  id: index,
                  name: leg,
                  publicName: legItem.publicName ? legItem.publicName : leg,
                });
              }
            })
          } else {
            legsArr.push({
              id: index,
              name: leg,
              publicName: leg
            })
          }
        })
        setLegs(legsArr);
        if (activeLeg === null) {
          charpstARConfig.setLegMaterial(legsArr[0].name);
        } else {
          if (legsArr[activeLeg].name) {
            charpstARConfig.setLegMaterial(legsArr[activeLeg].name);
          }
        }
      }
    }, 100);
    return () => clearInterval(intervalId);
  }, [isCharpstarLoaded, legs.length, activeProduct.legs, activeLeg, charpstARConfig]);


  useEffect(() => {
    if (!activeProduct) return;
    if (!productData) return;

    let tmpAvailableVariants = [];
    let defaultExists = false
    productData.variants.values.forEach((variant) => {
      if (variant.articleNumber === activeProduct.articleNumbers[0]) {
        defaultExists = true
      }
      if (activeProduct.articleNumbers.includes(variant.articleNumber)) {
        tmpAvailableVariants.push(variant.articleNumber);
      }
    });
    setAvailableVariants(tmpAvailableVariants);
    setDefaultArticleNumberForVariant(activeProduct.articleNumbers[0]);
  }, [activeProduct, productData]);

  useEffect(() => {
    if (activeTextileIndex === null) return
    if (!textiles[activeTextileIndex]) return
    if (!activeProduct) return;
    if (!availableVariants.length) return;

    const textileName = textiles[activeTextileIndex]?.name?.toLowerCase().trim();
    const configMatch = VariantTextileMapConfig.filter(
      (item) => item.prefix.toLowerCase().trim() === textileName
    );

    const variantArticleNumbers = productData?.variants?.values?.map(
      (variant) => variant.articleNumber
    ) || [];

    const matchingArticleNumbers = configMatch
      .map((item) => item.articleNumber)
      .filter((articleNumber) => variantArticleNumbers.includes(articleNumber));

    let selectedVariant = activeProduct.selectedVariant;

    const selectedVariantObj = productData?.variants?.values?.find(
      (variant) => variant.articleNumber === selectedVariant
    );

    const selectedArticleNumber = selectedVariantObj?.articleNumber
    const incVatPrice = selectedVariantObj?.price?.incVat;
    setSelectedVariant(selectedArticleNumber)
    setProductPrice(incVatPrice)
    const previousPrice = selectedVariantObj?.previousPrice?.incVat ? selectedVariantObj.previousPrice.incVat : 0;
    let pricePrevious = 0.00
    let discountPrice = 0.00
    let price = 0.00
    setProductPrice(0.00)
    if (previousPrice && incVatPrice !== selectedVariantObj?.previousPrice.incVat) {
      discountPrice = selectedVariantObj?.price.incVat
      pricePrevious = selectedVariantObj?.previousPrice.incVat
    } else {
      price = incVatPrice
    }
    if (discountPrice && discountPrice !== 0.00) {
      setDiscount(discountPrice.toString().replace('.', ','));
      if (pricePrevious) {
        setProductPrice(pricePrevious.toString().replace('.', ','));
      }
    } else {
      if (price) {
        setProductPrice(price.toString().replace('.', ','));
      }
    }

  }, [productData?.variants?.values, activeTextileIndex, textiles, productPrice, availableVariants, activeProduct, selectedVariant]);

  const brand = GetBrand(activeProduct.name)
  const images = inspirationImagesConfig[brand]?.filter(
    (img) => img.includes(activeProduct.inspirationImages)
  ) || []

  const checkForScrollPosition = (ref) => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth);
  };

  useEffect(() => {
    checkForScrollPosition(scrollRef);
    checkForScrollPosition(scrollRef2);
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener("scroll", checkForScrollPosition);
    return () => el.removeEventListener("scroll", checkForScrollPosition);
  }, []);

  useEffect(() => {
    checkForScrollPosition(scrollRef2);
    const el = scrollRef2.current;
    if (!el) return;
    el.addEventListener("scroll", checkForScrollPosition);
    return () => el.removeEventListener("scroll", checkForScrollPosition);
  }, []);

  // Render loading until client-only data is ready
  if (!activeProduct || !defaultArticleNumberForVariant || !availableVariants.length || !articleNumber || !textiles.length || !legs.length) {
    return (
      <>
        <div style={{position:'relative'}}>
          {(
            <PreviousButton onClick={() => scrollBy2(-500)}>
              <SvgWrapperReverse className={'black'} type={'button'}>
                <Carrot />
              </SvgWrapperReverse>
            </PreviousButton>
          )}
          <LastStep ref={scrollRef2}>
            <CharpstarContainer>
              <charpstar-container data-product={activeProduct.articleNumbers[0]}></charpstar-container>
            </CharpstarContainer>
          </LastStep>
          {(
            <NextButton onClick={() => scrollBy2(500)}>
              <SvgWrapper className={'black'} type={'button'}>
                <Carrot />
              </SvgWrapper>
            </NextButton>
          )}
        </div>
        <StyledWrapperStepSix
          id="3d-wrapper"
          className={activeText ? 'active' : ''}
        >
          <StepHeader>
            <div style={{ width: 'max-content' }}>
              <StepHeaderButtonPrev
                active={1}
                className={'hidden'}
                onClick={() => {
                  setCurrentStep((i) => i - 1);
                  window.sessionStorage.setItem('lastStep', currentStep - 1);
                }}
                setActiveLeg={activeLeg}
                setActiveTextileIndex={activeTextileIndex}
              >
                <SvgWrapperReverse>
                  <Carrot />
                </SvgWrapperReverse>
              </StepHeaderButtonPrev>
            </div>
            <StepHeaderText>
              {t('Sammanfattning')}
              <StepHeaderTextDescription>5/5</StepHeaderTextDescription>
            </StepHeaderText>
            <div style={{ width: 'max-content' }}>
              <StepHeaderButton
                active={1}
                onClick={() => {
                  setActiveText(!activeText);
                }}
              >
                <StepHeaderButtonText>
                  {activeText ? t('Visa') : t('Dölj')}
                </StepHeaderButtonText>
                <SvgWrapperDown className={activeText ? 'active' : ''}>
                  <Carrot />
                </SvgWrapperDown>
              </StepHeaderButton>
            </div>
          </StepHeader>
        </StyledWrapperStepSix>
      </>
    );
  }

  const json = JSON.stringify({
    defaultArticleNumber: activeProduct.defaultArticleNumber,
    selectedVariant: activeProduct.selectedVariant,
    activeTextileIndex: activeTextileIndex,
    activeLeg: activeLeg,
    activeCategory: activeCategory
  });

  const url = Buffer.from(json).toString('base64')

  return (
    <>
      <div style={{position:'relative'}}>
        {(
          <PreviousButton onClick={() => scrollBy(-500)}>
            <SvgWrapperReverse className={'black'} type={'button'}>
              <Carrot />
            </SvgWrapperReverse>
          </PreviousButton>
        )}
        <LastStep ref={scrollRef}>
          <CharpstarContainer>
            <charpstar-container data-product={activeProduct.articleNumbers[0]}></charpstar-container>
          </CharpstarContainer>
        </LastStep>
        {(
          <NextButton onClick={() => scrollBy(500)}>
            <SvgWrapper className={'black'} type={'button'}>
              <Carrot />
            </SvgWrapper>
          </NextButton>
        )}
      </div>
      <StyledWrapperStepSix
        id="3d-wrapper"
        className={activeText ? 'active' : ''}
      >
        <StepHeader>
          <div style={{ width: 'max-content' }}>
            <StepHeaderButtonPrev
              active={1}
              className={'hidden'}
              onClick={() => {
                setCurrentStep((i) => i - 1);
                setDefaultArticleNumberForVariant(null)
                setAvailableVariants([])
                setArticleNumber(null)
                window.sessionStorage.setItem('lastStep', currentStep - 1);
              }}
              setActiveLeg={activeLeg}
              setActiveTextileIndex={activeTextileIndex}
            >
              <SvgWrapperReverse>
                <Carrot />
              </SvgWrapperReverse>
            </StepHeaderButtonPrev>
          </div>
          <StepHeaderText>
            {t('Sammanfattning')}
            <StepHeaderTextDescription>5/5</StepHeaderTextDescription>
          </StepHeaderText>
          <div style={{ width: 'max-content' }}>
            <StepHeaderButton
              active={1}
              onClick={() => {
                setActiveText(!activeText);
              }}
            >
              <StepHeaderButtonText>
                {activeText ? t('Visa') : t('Dölj')}
              </StepHeaderButtonText>
              <SvgWrapperDown className={activeText ? 'active' : ''}>
                <Carrot />
              </SvgWrapperDown>
            </StepHeaderButton>
          </div>
        </StepHeader>
        <TextInfo className={activeText ? 'hide' : ''}>
          <ProductInfo>
            <ProductName>
              <b>{t('Produkt')}:</b> {Articles3DConfig.find((art) => art.articleNumber === activeProduct.selectedVariant)?.name || activeProduct.name}
            </ProductName>
            <ProductPriceSummary price={productPrice} discount={discount} />
            <ProductType>
              <b>{t('Tyg')}:</b> <span>{
              (
                ColorsAndTextilesConfig.textiles.find(
                  (t) => t.name === textiles[activeTextileIndex].name
                ) || {}
              ).publicName
            } / </span>
              {
                ColorsAndTextilesConfig.colors.map((color, index) => {
                  if (color.textiles.includes(textiles[activeTextileIndex].name)) {
                    return <span key={index}>{color.name}</span>;
                  }
                  return null;
                })
              }
            </ProductType>
            <ProductType>
              <b>{t('Ben')}:</b> <span>{legs[activeLeg].publicName}</span>
            </ProductType>
          </ProductInfo>

          <StyledButtonWrapper className={'button-wrapper'}>
            <Main3DButton
              text={'Lägg i varukorgen'}
              halfOnMobile={false}
              products={{ "articleNumber": articleNumber, "quantity": 1, "comments": [{ "name": 'Ben', "value": legs[activeLeg].publicName}]}}
              product={activeProduct}
              hasAdded={hasAdded}
              setHasAdded={setHasAdded}
              onClick={() => {
                setAddToCartClicked(true)
              }}
            ></Main3DButton>
            <Main3DButton
              link={productData.primaryRoute.path}
              text={'Besök produkt'}
              href={productData.primaryRoute.path}
              alternative={true}
              halfOnMobile={false}
            ></Main3DButton>
            <Main3DButton
              text={'DELA'}
              alternative={true}
              halfOnMobile={true}
              onClick={() => {
                setShare(true);
              }}
            ></Main3DButton>
            <Main3DButton
              link={'/butiker'}
              text={'Hitta butik'}
              href={'/butiker'}
              alternative={true}
              halfOnMobile={true}
              icon={<MapPin />}
            ></Main3DButton>
          </StyledButtonWrapper>
        </TextInfo>
        {share && <Popup url={url} onClose={() => setShare(false)} />}
      </StyledWrapperStepSix>
    </>
  );
};
